// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';
import { classMap } from 'lit/directives/class-map.js';

@customElement('product-rating')
export default class ProductRating extends LightElement {

	@property({ type: Number })
	reviewPercentage: number;

	@property({ type: Number })
	reviewCount: number;

	@property({ type: String })
	reviewCountTestName: string;

	@property({ type: Boolean })
	large: boolean;

	@property({ type: Boolean })
	alwaysLarge: boolean;

	@property({ type: Function })
	onRatingClick: () => void;

	@property({ type: Boolean })
	isClickable: boolean;

	@property({ type: String })
	reviewScore: string;

	@property({ type: Boolean })
	longText: boolean;

	@property({ type: Boolean })
	smallTextMobile: boolean;

	private handleRatingClick() {
		if (this.onRatingClick) {
			this.onRatingClick();
		}
	}

	render() {

		return html` 
			<div class="c-rating ${classMap({ "c-rating--large": this.large, "c-rating--always-large": this.alwaysLarge, "c-rating--clickable": this.isClickable, "c-rating--small-text-mobile": this.smallTextMobile })}" @click="${this.handleRatingClick}"> 
				<div class="c-rating__inner">
					<div class="c-rating__reveal" style="width: ${this.reviewPercentage}%"></div>
				</div>
				${this.longText ? html`<span class="c-rating__total">Rated ${this.reviewScore}/5 from <span class="c-rating__link">${this.reviewCount} customer review${this.reviewCount !== 1 ? "s" : ""}</span></span>`
				: html`<span class="c-rating__total" data-test="${this.reviewCountTestName || nothing}">(${this.reviewCount})</span>`}
			</div>
		`;

	}

}
